import { call, delay, put, takeEvery } from 'redux-saga/effects';
import { POST_CONSUMPTION, postConsumptionAsync } from './actions';
import { apiPostConsumption } from '../../lib/common/api';
import { PostConsumptionResponseType } from '../../lib/common/type';

function* postConsumptionSaga(
  action: ReturnType<typeof postConsumptionAsync.request>
) {
  yield delay(100);
  try {
    const response: PostConsumptionResponseType = yield call(
      apiPostConsumption,
      action.payload
    );
    yield put(postConsumptionAsync.success(response));
  } catch (error) {
    yield put(postConsumptionAsync.failure(error));
  }
}

export function* commonSaga() {
  yield takeEvery(POST_CONSUMPTION, postConsumptionSaga);
}

export { commonSaga as default };
